import { TourProvider } from '@reactour/tour';
import { ToastContainer } from 'react-toastify';
import { I18nextProvider } from 'react-i18next';
import * as locales from '@mui/material/locale';
import { LicenseInfo } from '@mui/x-license-pro';
import { Routes, Route, Outlet } from 'react-router-dom';
import { useContext, useEffect, useMemo, useState } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import './App.css';
import i18n from './i18n';
import './themes/dark.scss';
import './scss/_general.scss';
import Login from './pages/Login';
import { routes } from './routes';
import theme from './themes/generalTheme';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FilteredRoutes } from './routesPerm';
import Navbar from './components/Navbar/Navbar';
import ErrorScreen from './components/ErrorScreen';
import RecoverScreen from './components/RecoverScreen';
import NonAuthScreen from './components/NonAuthScreen';
import AcquireScreen from './components/AcquireScreen';
import NewSidebar from './components/ProSidebar/ProSidebar';
import { DarkModeContext } from './context/darkModeContext';
import useGeolocationHandler from './hooks/UseGeolocationHandler';
import EquipmentsIframeTable from './components/Tables/Sigma/EquipmentsIframeTable';

const App = () => {
  const muiKey = process.env.REACT_APP_MUI_PRO_KEY;
  LicenseInfo.setLicenseKey(muiKey);

  const userToken = localStorage.getItem('token');

  const { darkMode } = useContext(DarkModeContext);

  const [locale, setLocale] = useState('esES');

  useEffect(() => {
    if (i18n.language === 'es') {
      setLocale('esES');
    } else if (i18n.language === 'en') {
      setLocale('enUS');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  const themeWithLocale = useMemo(
    () => createTheme(theme, locales[locale]),
    [locale]
  );

  useEffect(() => {
    if (
      !userToken &&
      ![
        '/',
        '/nonauth',
        '/recovery',
        '/acquire',
        '/recovery',
        '/nonperm',
        '/equipment-iframe',
      ].includes(window.location.pathname)
    ) {
      window.location.href = '/nonauth';
    }
  }, [userToken]);

  useGeolocationHandler();

  const Layout = () => (
    <>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider theme={themeWithLocale}>
          <div className={darkMode ? 'app dark' : 'app'}>
            <div className='app'>
              <NewSidebar />
              <main className='content'>
                <Navbar />
                <ToastContainer />
                <div className='page-content'>
                  <TourProvider
                    styles={{
                      popover: (base) => ({
                        ...base,
                        '--reactour-accent': '#dc1f0f',
                      }),
                    }}
                  >
                    <Outlet />
                  </TourProvider>
                </div>
              </main>
            </div>
          </div>
        </ThemeProvider>
      </I18nextProvider>
    </>
  );

  return (
    <Routes>
      <Route element={<Layout />}>
        {FilteredRoutes({ routes }).map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}
      </Route>
      <Route path='/equipment-iframe' element={<EquipmentsIframeTable />} />
      <Route path='/acquire' element={<AcquireScreen />} />
      <Route path='/nonperm' element={<ErrorScreen />} />
      <Route path='/nonauth' element={<NonAuthScreen />} />
      {/* <Route path="*" element={<NonAuthScreen />} /> */}
      <Route exact path='/' element={<Login />} />
      <Route exact path='/recovery' element={<RecoverScreen />} />
    </Routes>
  );
};

export default App;
